import axios from 'axios'

export async function getBubbleList({ pageNum, pageSize, status }) {
  const res = await axios.get(
    `/mobile/msgm/list?pageNum=${pageNum}&pageSize=${pageSize}&status=${status}`
  )
  if (res.status !== 200) {
    throw new Error('出错了！')
  }
  return res.data
}

export async function getBapingmsgmList({ pageNum, pageSize }) {
  const res = await axios.get(
    `/mobile/bapingmsgm/list?pageNum=${pageNum}&pageSize=${pageSize}`
  )
  if (res.status !== 200) {
    throw new Error('出错了！')
  }
  return res.data
}

export async function getconfiglivemarkList({ huodongId }) {
  const res = await axios.get(`/ims/configlivemark/list?huodongId=${huodongId}`)
  if (res.status !== 200) {
    throw new Error('出错了！')
  }
  return res.data
}

export async function editBapingmsgm(id) {
  const res = await axios.post('/mobile/bapingmsgm/edit', {
    id: id,
    iswcbapin: 2,
  })
  if (res.status !== 200) {
    throw new Error('出错了！')
  }
  return res.data
}
// 查询活动配置详细
export async function getHuodongconfig(id) {
  const res = await axios.get(`/ims/huodongconfig/${id}`)
  if (res.status !== 200) {
    throw new Error('出错了！')
  }
  return res.data
}

export async function getnormaldata({ huodongId }) {
  const res = await axios.get(
    `/ims/livemarkuser/getnormaldata?huodongId=${huodongId}`
  )
  if (res.status !== 200) {
    throw new Error('出错了！')
  }
  return res.data
}

export async function getLivemarkrotate({ huodongId }) {
  const res = await axios.get(`/ims/livemarkrotate/list?huodongId=${huodongId}`)
  if (res.status !== 200) {
    throw new Error('出错了！')
  }
  return res.data
}

// 题目列表
export async function getAnswerbsquestionList({ status }) {
  const res = await axios.get(`/scoring/answerbsquestion/list?status=${status}`)
  if (res.status !== 200) {
    throw new Error('出错了！')
  }
  return res.data
}

// 答题记录（结果）
export async function getAnswerbrecordList({ squestionId }) {
  const res = await axios.get(
    `/scoring/answerbrecord/list?squestionId=${squestionId}`
  )
  if (res.status !== 200) {
    throw new Error('出错了！')
  }
  return res.data
}

// 开始答题/结束答题
export async function updateAnswerbsquestion(updateData) {
  const res = await axios.put(`/scoring/answerbsquestion`, updateData)
  if (res.status !== 200) {
    throw new Error('出错了！')
  }
  return res.data
}

// 查询题目详细
export async function getAnswerbsquestion(id) {
  const res = await axios.get('/scoring/answerbsquestion/' + id)
  if (res.status !== 200) {
    throw new Error('出错了！')
  }
  return res.data
}

export async function getLanternList({ pageNum, pageSize, huodongId, status }) {
  const res = await axios.get(
    `/scoring/lantern/list?pageNum=${pageNum}&pageSize=${pageSize}&huodongId=${huodongId}&status=${status}`
  )
  if (res.status !== 200) {
    throw new Error('出错了！')
  }
  return res.data
}


export async function getUserList({ pageNum, pageSize }) {
  const res = await axios.get(
    `/api/user/list?pageNum=${pageNum}&pageSize=${pageSize}`
  )
  if (res.status !== 200) {
    throw new Error('出错了！')
  }
  return res.data
}

export async function getLiveNormaldata({ huodongId, rotateId }) {
  const res = await axios.get(
    `scoring/livemarkuser/getnormaldata?huodongId=${huodongId}&rotateId=${rotateId}`
  )
  if (res.status !== 200) {
    throw new Error('出错了！')
  }
  return res.data
}

export async function getSystemSetting({ rotateId }) {
  const res = await axios.get(`/api/systemSetting/${rotateId}`)
  if (res.status !== 200) {
    throw new Error('出错了！')
  }
  return res.data
}
export async function getSystemList({ pageNum, pageSize, rotateId }) {
  const res = await axios.get(
    `/api/user/list?pageNum=${pageNum}&pageSize=${pageSize}&rotateId=${rotateId}`
  )
  if (res.status !== 200) {
    throw new Error('出错了！')
  }
  return res.data
}

export async function systemSettingUpdate(updateData) {
  const res = await axios.put(`/api/systemSetting`, updateData)
  if (res.status !== 200) {
    throw new Error('出错了！')
  }
  return res.data
}

export async function lanternaJaxhis() {
  const res = await axios.post('/express/screen/lantern/ajaxhis', {
    hdid: "M571fgF2IjejXIx88uXu2uDi77u5Ge54",
  })

  if (res.data.code !== 0) {
    throw new Error('出错了！')
  }
  return res.data.msg
}
